"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultStandupQuestions = void 0;
const createNominalQuestion_1 = require("../utils/createNominalQuestion");
const createOpenEndedQuestion_1 = require("../utils/createOpenEndedQuestion");
const randomString_1 = require("../utils/randomString");
function createDefaultStandupQuestions() {
    return [
        (0, createOpenEndedQuestion_1.createOpenEndedQuestion)({
            required: false,
            label: "What did you accomplish since the last check-in?",
        }),
        (0, createOpenEndedQuestion_1.createOpenEndedQuestion)({
            required: false,
            label: "What are you working on next?",
        }),
        (0, createNominalQuestion_1.createNominalQuestion)({
            required: false,
            allowUserAddOptions: false,
            allowMultipleChoices: false,
            label: "Are there any issues blocking your progress?",
            choices: [
                { id: (0, randomString_1.randomString)(), value: "✅ Not Blocked" },
                { id: (0, randomString_1.randomString)(), value: "🛑 Blocked" },
            ],
            allowComments: true,
            commentAppeal: "How can the issues be resolved to help you unblock?",
        }),
    ];
}
exports.createDefaultStandupQuestions = createDefaultStandupQuestions;
//# sourceMappingURL=createDefaultStandupQuestions.js.map